import { cn } from '@/lib/utils';
import { type ReactNode } from 'react';

type CardVariant = 'default' | 'dark' | 'interactive';

interface CardProps {
  variant?: CardVariant;
  children: ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
}

const variantStyles: Record<CardVariant, string> = {
  default: 'bg-white border border-slate-200',
  dark: 'bg-slate-800/50 backdrop-blur-sm border border-slate-700',
  interactive:
    'bg-white border border-slate-200 hover:border-teal-200 hover:shadow-md transition-all',
};

const paddingStyles = {
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-5',
};

export function Card({
  variant = 'default',
  children,
  className,
  padding = 'md',
}: CardProps) {
  return (
    <div
      className={cn(
        'rounded-xl',
        variantStyles[variant],
        paddingStyles[padding],
        className
      )}
    >
      {children}
    </div>
  );
}
